__webpack_require__.p = "/Game_Of_Life/";